import FormScheduleMessage from './FormScheduleMessage';

export default FormScheduleMessage;
